import { reqDelete, reqGet } from './index';

export const fetchTagList = param => reqGet('/v3/api/common/tag', { ...param });
export const fetchScannerList = param => reqGet('/v3/api/common/scanner', { ...param, isAll: 'Y' });
export const fetchIotItemCount = param => reqGet('/v3/api/common/statistics/category/by-target/count', { ...param });
// 태그 배터리 상태 조회
export const fetchTagBatteryCount = param =>
    reqGet('/v3/api/common/statistics/mapped-tag-battery/by-unit/count', { ...param });

//// 자산 현황
// 카테고리 리스트 호출
export const fetchCategory = param => reqGet('/v3/api/common/target/category/info', { ...param });

// 현재 자산 현황 개수 데이터 호출 (전체 개수, lost signal 개수 etc..)
export const fetchAssetCountStatus = param =>
    reqGet('/v3/api/common/statistics/category/target/tag/by-status/count', { ...param });

// 실시간 위치 정보가 맵핑된 대상 목록 조회 API
export const getTargetListWithLocationApi = param =>
    reqGet('/v3/api/common/statistics/category/target/location/info', { ...param });

//// 실시간 위치 현황
export const fetchIotItemList = param => reqGet('/v3/api/common/target/info', { ...param });
export const getIotItemApi = param => reqGet(`/v3/api/common/target/info/${param.targetNum}`);

// 모든 ioT 항목 수
export const fetchIoTItemCount = param => reqGet('/v3/api/common/statistics/count-by-category/count', { ...param });

//// 센서 현황
//매핑된 센서 현황 수 조회
export const getMappedSensorStatusApi = param => reqGet('/v3/api/common/statistics/sensor/total/count', param);

export const getAssetStatusListApi = param => reqGet('/v3/api/common/target/status/category/info', param);

export const getOwnershipListApi = param => reqGet('/v3/api/common/user/group/info', param);

////두산 메카텍
//모든 안전기기(태그 센서)일괄 매핑해제
export const deleteUnmappingDevicesApi = param => reqDelete(`/v3/api/dm/target/device/${param.roleName}`);
